import { format, isSameDay, isValid, parseISO, startOfDay } from 'date-fns';
import { MAX_MULTI_DAY_VISITS } from 'shared/consts';

export const toDateOnlyString = (date: Date): string => format(startOfDay(date), 'yyyy-MM-dd');

export const parseDateOnlyString = (value: string): Date | null => {
  const parsed = parseISO(value);
  return isValid(parsed) ? startOfDay(parsed) : null;
};

export const sortVisitDates = (dates: Date[]): Date[] =>
  [...dates].sort((left, right) => startOfDay(left).getTime() - startOfDay(right).getTime());

export const capVisitDates = (dates: Date[]): Date[] => {
  const sorted = sortVisitDates(dates);
  if (sorted.length <= MAX_MULTI_DAY_VISITS) {
    return sorted;
  }
  return sorted.slice(0, MAX_MULTI_DAY_VISITS);
};

export const datesToDateOnlyStrings = (dates: Date[]): string[] =>
  sortVisitDates(dates).map((date) => toDateOnlyString(date));

export const getEarliestVisitDate = (dates: Date[]): Date | null => {
  if (dates.length === 0) {
    return null;
  }
  return sortVisitDates(dates)[0] ?? null;
};

export const hasSameCalendarDay = (left: Date, right: Date): boolean => isSameDay(startOfDay(left), startOfDay(right));

export const toggleVisitDate = (dates: Date[], candidate: Date): Date[] => {
  const exists = dates.some((date) => hasSameCalendarDay(date, candidate));
  if (exists) {
    const remaining = dates.filter((date) => !hasSameCalendarDay(date, candidate));
    return remaining.length > 0 ? sortVisitDates(remaining) : dates;
  }
  if (dates.length >= MAX_MULTI_DAY_VISITS) {
    return sortVisitDates(dates);
  }
  return sortVisitDates([...dates, startOfDay(candidate)]);
};

export const uniqueSortedDateStrings = (values: string[]): string[] =>
  Array.from(new Set(values.filter(Boolean))).sort((left, right) => left.localeCompare(right));
